import React from "react";
import { PropTypes } from "prop-types";
import { themes } from "../../theme";

const FraudulentActivityIcon = ({ children, color, ...props }) => (
  <svg
    {...props}
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    {children}
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      {...color !== "currentColor" && { fillOpacity: ".65" }}
    >
      <g
        transform="translate(-196.000000, -140.000000)"
        fill={color}
        fillRule="nonzero"
      >
        <g transform="translate(196.000000, 140.000000)">
          <path d="M15,14 L15,12.5 C15,10.5670034 16.5670034,9 18.5,9 C20.4329966,9 22,10.5670034 22,12.5 L22,14 L22.5,14 C23.3284271,14 24,14.6715729 24,15.5 L24,22.5 C24,23.3284271 23.3284271,24 22.5,24 L14.5,24 C13.6715729,24 13,23.3284271 13,22.5 L13,15.5 C13,14.6715729 13.6715729,14 14.5,14 L15,14 Z M16,14 L21,14 L21,12.5 C21,11.1192881 19.8807119,10 18.5,10 C17.1192881,10 16,11.1192881 16,12.5 L16,14 Z M15.5,15 L14.5,15 C14.2238576,15 14,15.2238576 14,15.5 L14,22.5 C14,22.7761424 14.2238576,23 14.5,23 L22.5,23 C22.7761424,23 23,22.7761424 23,22.5 L23,15.5 C23,15.2238576 22.7761424,15 22.5,15 L21.5,15 L15.5,15 Z M22,5 L1,5 L1,17.5025781 C1,18.331522 1.66998831,19 2.49961498,19 L10.5,19 C10.7761424,19 11,19.2238576 11,19.5 C11,19.7761424 10.7761424,20 10.5,20 L2.49961498,20 C1.11820813,20 0,18.8843126 0,17.5025781 L0,2.49742191 C0,1.1179317 1.11372966,0 2.491155,0 L20.508845,0 C21.8874741,0 23,1.11336813 23,2.49810135 L23,8.5 C23,8.77614237 22.7761424,9 22.5,9 C22.2238576,9 22,8.77614237 22,8.5 L22,5 Z M1,4 L22,4 L22,2.49810135 C22,1.66548355 21.3350199,1 20.508845,1 L2.491155,1 C1.66685917,1 1,1.66937519 1,2.49742191 L1,4 Z M18,17.5 C18,17.2238576 18.2238576,17 18.5,17 C18.7761424,17 19,17.2238576 19,17.5 L19,20.5 C19,20.7761424 18.7761424,21 18.5,21 C18.2238576,21 18,20.7761424 18,20.5 L18,17.5 Z M3.5,2 C3.776,2 4,2.225 4,2.5 C4,2.776 3.776,3 3.5,3 C3.224,3 3,2.776 3,2.5 C3,2.225 3.224,2 3.5,2 Z M5.5,2 C5.776,2 6,2.225 6,2.5 C6,2.776 5.776,3 5.5,3 C5.224,3 5,2.776 5,2.5 C5,2.225 5.224,2 5.5,2 Z M7.5,2 C7.776,2 8,2.225 8,2.5 C8,2.776 7.776,3 7.5,3 C7.224,3 7,2.776 7,2.5 C7,2.225 7.224,2 7.5,2 Z" />
        </g>
      </g>
    </g>
  </svg>
);

FraudulentActivityIcon.displayName = "FraudulentActivityIcon";

FraudulentActivityIcon.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string
};

FraudulentActivityIcon.defaultProps = {
  children: null,
  color: themes.global.gray01
};

export default FraudulentActivityIcon;
